import React from "react";
import { Typography, Grid, InputAdornment } from "@mui/material";
import { TextValidator } from "react-material-ui-form-validator";

const INK = "#0F172A";
const MUTED = "#475569";
const BORDER = "#D9E2EC";
const BRAND = "#F9735B";

const FormField = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder,
  icon,
  endIcon,
  required = false,
  multiline = false,
  rows = 1,
  select = false,
  children,
  gridSize = 12,
  validators = [],
  errorMessages = [],
  SelectProps,
}) => {
  return (
    <Grid item size={gridSize}>
      <Typography
        component="label"
        sx={{
          display: "block",
          mb: 0.6,
          ml: 0.25,
          fontSize: "0.88rem",
          fontWeight: 600,
          fontFamily: '"Inter", sans-serif',
          color: MUTED,
        }}
      >
        {label}
      </Typography>
      <TextValidator
        fullWidth
        onChange={onChange}
        name={name}
        type={type}
        value={value}
        validators={required ? ["required", ...validators] : validators}
        errorMessages={
          required ? [`${label} is required`, ...errorMessages] : errorMessages
        }
        placeholder={placeholder}
        multiline={multiline}
        rows={rows}
        select={select}
        SelectProps={SelectProps}
        InputProps={{
          startAdornment: icon ? (
            <InputAdornment
              position="start"
              sx={multiline ? { alignSelf: "flex-start", mt: 2 } : {}}
            >
              {icon}
            </InputAdornment>
          ) : undefined,
          endAdornment: endIcon ? (
            <InputAdornment position="end">{endIcon}</InputAdornment>
          ) : undefined,
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "#fff",
            fontFamily: '"Inter", sans-serif',
            "& fieldset": {
              borderColor: BORDER,
              borderWidth: "1.5px",
            },
            "&:hover fieldset": {
              borderColor: "#B9C7D8",
            },
            "&.Mui-focused fieldset": {
              borderColor: BRAND,
              borderWidth: "2px",
            },
          },
          "& .MuiInputBase-input": {
            color: INK,
            fontSize: "0.93rem",
          },
          "& .MuiFormHelperText-root.Mui-error": {
            fontFamily: '"Inter", sans-serif',
            marginLeft: 0.25,
          },
        }}
      >
        {children}
      </TextValidator>
    </Grid>
  );
};

export default FormField;
